import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBus: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bus, school-bus"><path d="M7.75 20.25H3.75V3.75H20.25V20.25H16.25V18.25H7.75V20.25Z" stroke="currentColor" strokeWidth="1.5"/><path d="M4 12.25H20" stroke="currentColor" strokeWidth="1.5"/><path d="M6 15.25H9" stroke="currentColor" strokeWidth="1.5"/><path d="M15 15.25H18" stroke="currentColor" strokeWidth="1.5"/><path d="M1 7.75L4 7.75" stroke="currentColor" strokeWidth="1.5"/><path d="M20 7.75L23 7.75" stroke="currentColor" strokeWidth="1.5"/><path d="M9 6.25H15" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBus;
